import { BlockBlobClient } from '@azure/storage-blob'
import { getApiClient } from '../api-client'

const triggerDownload = (blob: Blob, filename: string): void => {
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
  URL.revokeObjectURL(url)
}

export const downloadDocumentFromAzureStorage = async (filename: string, sasTokenUrl: string) => {
  try {
    const blockBlobClient = new BlockBlobClient(sasTokenUrl)
    const downloadResponse = await blockBlobClient.download()
    const blob = await downloadResponse.blobBody

    if (!blob) {
      throw new Error('Failed to download file')
    }

    triggerDownload(blob, filename)
  } catch (error) {
    console.error('Error downloading file:', error)
    throw error
  }
}

export const downloadDocumentFromAPI = async (filename: string, path: string) => {
  try {
    const apiClient = getApiClient()
    const response = await apiClient.get<Blob>(path, {
      responseType: 'blob',
    })

    let name = filename
    const contentDisposition = response.headers['content-disposition'] as string | undefined
    if (contentDisposition) {
      const regex = /filename="(.+?)"/
      const match = regex.exec(contentDisposition)
      name = match?.[1] ?? name
    }

    const blob = new Blob([response.data])
    triggerDownload(blob, name)
  } catch (error) {
    console.error('Error downloading file:', error)
    throw error
  }
}
